<template>
  <v-card>
    <v-card-text>
      <v-row>
        <v-col cols="12" md="12" class="font-weight-bold primary--text pt-0 mb-3" style="font-size:16px;">
          {{ i18n['net_profit_calculator']}}
        </v-col>
        <v-col cols="12" md="3" class="py-0 px-1" v-for="(field, f) in form" :key="'fieldcal-'+f">
          <Field :field="field" :item="calculation" :index="f" />
        </v-col>
        <v-col cols="12" md="12">
          <v-row>
            <v-col cols="12" :md="12/show_stat.length" class="py-1 px-1" v-for="(item, i) in show_stat" :key="'stat-'+i">
              <v-card :loading="loading" class="statCard">
                <v-card-text>
                  <div :class="`${arabic?'arFont':'enFont'} pb-2`" style="font-size:16px;">
                    {{i18n[item]}}
                  </div>
                  <div style="font-size:22px;font-weight:700;">{{ getComputedProperty(item) }}</div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" md="12" class="py-0 px-1">
          {{ i18n['net_profit_calculator_details']}}
        </v-col>
        
        <v-col cols="12" md="12" class="py-0 px-1">
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="">
                    {{ i18n['net_profit_calculator_item']}}
                  </th>
                  <th class="">
                    {{ i18n['net_profit_calculator_result']}}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item, i) in show_table"
                  :key="'col-'+i"
                >
                  <td>{{ getTranslate(item) }}</td>
                  <td>{{getComputedProperty(item) }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import Field from '@/components/Field.vue';
export default {
  props:['prices', 'fees', 'loading'],
   components: {
    Field,
  },
  data(){
    return {
      calculation:{
        leads:100,
        lead_cost:1.5,
        confirmation_rate:60,
        delivery_rate:60,
        items_per_order: 1,
        price: this.$props.prices.map(x=>{return{...x, ...x.country, text:x.country.name}})[0],
        sale_price: this.$props.prices.map(x=>{return{...x, ...x.country, text:x.country.name}})[0].suggested_sale_price,
      },
      form:[
        {
          name: "price",
          type: 'select',
          returnObject:true,
          label: 'country',
          data:[...this.$props.prices.map(x=>{return{...x, ...x.country, text:x.country.name}})],
          info: { en: '', ar: '' },
        },
        {
          name: "leads",
          type: 'number',
          label: 'leads',
          info: { en: '', ar: '' },
        },
        {
          name: "items_per_order",
          type: 'number',
          label: 'items_per_order',
          info: { en: '', ar: '' },
        },
        {
          name: "lead_cost",
          type: 'number',
          label: 'lead_cost',
          info: { en: '', ar: '' },
        },
        {
          name: "confirmation_rate",
          type: 'number',
          label: 'confirmation_rate',
          info: { en: '', ar: '' },
        },
        {
          name: "delivery_rate",
          type: 'number',
          label: 'delivery_rate',
          info: { en: '', ar: '' },
        },
        {
          name: "sale_price",
          type: 'number',
          label: 'sale_price',
          info: { en: '', ar: '' },
        },
      ],
      show_table:[
        'ads_cost', 
        'confirmed_orders_count',
        'delivered_orders_count',
        'items_count',
        'cost_of_goods',
        'investment',
        'sales',
        'call_center_fees',
        'shipping_fees',
        'cod_fees',
        'total_fees',
        'net_profit',
        'roi',
      ],
      show_stat:[
        'investment',
        'net_profit',
        'roi',
      ]
    }
  },
  methods:{
    getTranslate(item) {
      return this.i18n[item] || item
    },
    getComputedProperty(propName) {
      return this.getPrefix(propName) + this.roundNumber(this[propName]);
    },
    roundNumber(num){
      return num.toFixed(2)
    },
    getPrefix(propName){
      if(propName.includes('count')) {
        return ''
      } else if(propName === 'roi') {
        return '%'
      } else {
        return '$'
      }
    }
  },
  watch:{
    // calculation: {
    //   handler(newValue, oldValue) {
    //     if(newValue.price) {
    //       this.calculation.sale_price = newValue.price.suggested_sale_price
    //     }
    //   },
    //   deep: true
    // }
    calculationPrice(newValue, oldValue) {
      console.log('Price changed:', newValue);
      if(newValue) {
        this.calculation.sale_price = newValue.suggested_sale_price
      }
    }
  },
  computed:{
    calculationPrice() {
      return this.calculation.price;
    },
    ads_cost(){
      if(!this.calculation.leads || !this.calculation.lead_cost) return 0
      return this.calculation.leads * this.calculation.lead_cost
    },
    items_count() {
      if(!this.delivered_orders_count || !this.calculation.items_per_order) return 0
      return this.delivered_orders_count * this.calculation.items_per_order
    },
    cost_of_goods(){
      if(!this.items_count || !this.calculation.price || !this.calculation.price.price) return 0
      return this.items_count  * parseFloat(this.calculation.price.price)
    },
    confirmed_orders_count(){
      if(!this.calculation.leads || !this.calculation.confirmation_rate) return 0
      return this.calculation.leads * this.calculation.confirmation_rate / 100
    },
    canceled_orders_count(){
      if(!this.calculation.leads || !this.calculation.confirmation_rate) return 0
      return this.calculation.leads * ((100 - this.calculation.confirmation_rate) / 100)
    },
    delivered_orders_count(){
      if(!this.confirmed_orders_count || !this.calculation.delivery_rate) return 0
      return this.confirmed_orders_count * this.calculation.delivery_rate / 100
    },
    failed_delivered_orders_count(){
      if(!this.confirmed_orders_count || !this.calculation.delivery_rate) return 0
      return this.confirmed_orders_count * ((100 - this.calculation.delivery_rate) / 100)
    },

    country_fees() {
      if(!this.fees.length || !this.calculation.price || !this.calculation.price.price) return false
      return this.fees.filter(x=>x.country_id == this.calculation.price.country_id)[0]
    },
    failed_shipping_fees(){
      if(!this.failed_delivered_orders_count || !this.country_fees) return 0
      return this.failed_delivered_orders_count * this.country_fees.per_special_shipping
    },
    success_shipping_fees(){
      if(!this.delivered_orders_count || !this.country_fees) return 0
      return this.delivered_orders_count * this.calculation.price.country.cityWithHighestFee.fee
    },
    shipping_fees(){
      return this.failed_shipping_fees + this.success_shipping_fees
    },
    call_center_fees(){
      if(!this.canceled_orders_count || !this.delivered_orders_count  || !this.country_fees) return 0
      return this.delivered_orders_count * this.country_fees.per_order 
      + this.canceled_orders_count * this.country_fees.per_Human 
      + ((this.confirmed_orders_count - this.delivered_orders_count) * this.country_fees.per_confirmed)
    },
    cod_fees(){
      if(!this.sales || !this.country_fees) return 0
      return this.sales * this.country_fees.cod_fee
    },
    total_fees(){
      return this.cod_fees + this.call_center_fees + this.shipping_fees
    },
    sales(){
      console.log(this.calculation.sale_price)
      if(!this.delivered_orders_count || !this.calculation.sale_price) return 0
      return this.delivered_orders_count * this.calculation.sale_price
    },
    investment(){
      return this.ads_cost + this.cost_of_goods
    },
    net_profit(){
      return this.sales - this.investment - this.total_fees
    },
    roi(){
      if(!this.net_profit || !this.investment) return 0
      return this.net_profit / this.investment * 100
    },
    language() {
      return this.$store.state.language;
    },
    i18n() {
      return this.$store.state.i18n[this.$store.state.language];
    },
    arabic() {
      if (this.$store.state.language == "ar")
        return true;
    },
  }
}
</script>

<style>
.statCard {
  border-top: solid 5px #9f0019 !important;
  border-bottom: solid 3px #9f0019 !important;
}
</style>